import { Component, inject, input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { EnvConfigBrand } from '@core/config-models';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { CommodityOfferAlignment } from '../commodity-offers.model';
import { BrandHeaderComponent } from '@legacy/common-ui-partials';
import { CommonModule } from '@angular/common';
import { GenericRichTextDirective } from '@core/jss-utils';
import { CrntIcon } from '@essent/current-web-angular';

@Component({
  selector: 'wl-commodity-offer-header',
  templateUrl: './commodity-offer-header.component.html',
  styleUrls: [
    './commodity-offer-header.component.ed.scss',
    './commodity-offer-header.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    BrandHeaderComponent,
    CSCaptureDirective,
    GenericRichTextDirective,
    CrntIcon,
  ],
})
export class CommodityOfferHeaderComponent {
  brand: EnvConfigBrand = inject(ENVIRONMENT_CONFIG).brand;

  readonly headerTitle = input<string>();
  readonly alignment = input.required<CommodityOfferAlignment>();
  readonly showBrandHeader = input(true);
  readonly redeliveryNotice = input<RichTextField>();
}
